import React, { FC, Fragment, useEffect, useState } from "react";
import {
  ActionBtn,
  FormBody,
  FormContainer,
  FormWrapper,
  HeaderView,
  ImageSection,
  SectionTitle,
  SectionWrapper,
} from "./styleCreateCoin";
import ViewHeader from "../../components/ViewHeader/ViewHeader";
import { adminRouts } from "../../routs";
import FormBuilder from "../FormBuilder/FormBuilder";
import {
  FormElement,
  FormElementType,
  InputTypes,
  InputVariant,
  NotificationType,
  customValidationType,
} from "../../Utility/InterFacesAndEnum";
import { updateFormInputState } from "../../Utility/Utility";
import CoinImageUploader from "../../components/ImageUploader/CoinImageUploader";
import CoinThumbnailUploader from "../../components/ImageUploader/CoinThumbnailUploader";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/Store";
import Button from "../../components/UI/Button/Button";
import { nanoid } from "@reduxjs/toolkit";
import { toggleNotificationVisibility } from "../../features/networkNotification";
import { validateCreateCoin } from "../../Utility/formValidation";
import { createCoin, getCoinsById, updateCoin } from "../../features/coinSlice";
import { useNavigate, useParams } from "react-router-dom";
import { resetImages, resetThumbnail, setImages, setThumbnail } from "../../features/imageUploaderSlice";

interface FormState {
  form: FormElement[];
  isValidForm: boolean;
}

enum ButtonSize {
  sm = "small",
  md = "medium",
  lg = "large",
}
enum ButtonVariant {
  primaryFilled = "primary-filled",
  secondary = "secondary",
  primaryLink = "primaryLink",
  danger = "danger",
}

interface SingleCoin {
  coinId: number;
  coinTitle: string;
  coinPrice: string;
  coinDescription: string;
  coinCode: string;
  isPublished: boolean;
  coinThumbnailImageUrl: string;
  coinImageUrls: [];
}

const CoinDetails: FormState = {
  form: [
    {
      elementType: FormElementType.input,
      value: "",
      id: "coinTitle",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.text,
      customValidationType: customValidationType.numberValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Title",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
    {
      elementType: FormElementType.textArea,
      value: "",
      id: "coinDescription",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.text,
      customValidationType: customValidationType.numberValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Description",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
    {
      elementType: FormElementType.input,
      value: "",
      id: "coinPrice",
      isRequired: true,
      fullWidth: true,
      isCustomValidationRequred: true,
      inputVariant: InputVariant.outlined,
      inputType: InputTypes.number,
      customValidationType: customValidationType.numberValidation,
      isValidInput: false,
      isTouched: false,
      errorMessage: "",
      label: "Coin Price",
      radioGroupValues: [],
      isPasswordHidden: true,
      dropdownValues: [],
      selectedTime: null,
      slectedDate: null,
      disabled: false,
    },
  ],
  isValidForm: true,
};

const UpdateCoin: FC = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const singleCoin = useSelector((state: RootState) => state.coin.singleCoin);
  console.log(singleCoin)
  const { thumbnail, thumbnailName, images, imageNames } = useSelector(
    (state: RootState) => state.images
  );
  const isNavigate = useSelector((state: RootState) => state.coin.isNavigate);
  const navigate = useNavigate();


  const [coinDetail, setCoinDetail] = useState<FormState>(CoinDetails);


  useEffect(() => {
    dispatch(getCoinsById(params.coinId));
  }, [params.coinId]);



  const mapCoinResponse = (formElements: FormElement[]) => {
    let updatedFormElement = formElements.map((element) => {
      let updatedElement = {
        ...element,
      };
      updatedElement["value"] = singleCoin[element.id];
   

      return updatedElement;
    });
    return updatedFormElement;
  };


  useEffect(() => {

    let updatedForm = mapCoinResponse(coinDetail.form);
    setCoinDetail({...coinDetail, form:updatedForm})
    if (thumbnail.length >= 1) {
      // window.location.reload();
      dispatch(resetThumbnail());
      dispatch(resetImages());
    }

    if (Object.keys(singleCoin).length !== 0) {
      dispatch(
        setThumbnail({
          data: [singleCoin.coinThumbnailImageUrl],
          names: [singleCoin.coinThumbnailImage],
        })
      );
      dispatch(
        setImages({
          data: singleCoin.coinImageUrls,
          names: singleCoin.coinImages,
        })
      );
    }
    // console.log("sorry");
  }, [singleCoin]);

  useEffect(() => {
    if (isNavigate) {
      navigate(adminRouts.coinList);
    }
  }, [isNavigate]);
  const handleCoinInputChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ): void => {
    let updatedStateArray = updateFormInputState(event, coinDetail.form);
    setCoinDetail({
      ...coinDetail,
      form: updatedStateArray,
    });
  };
  const createCoinView = (
    <FormBuilder
      formElements={coinDetail.form}
      onInputChange={handleCoinInputChange}
      onSelectValueChange={() => {}}
      onChangeDate={() => {}}
      onChangeTime={() => {}}
    />
  );
  const validateForm = () => {
    let formElementArray = [...coinDetail.form];
    let requestObj: any = {};
    for (let formElement of formElementArray) {
      requestObj[formElement.id] = formElement.value;
    }
    // requestObj['coinId']=coinId;
    requestObj["coinThumbnailImage"] = thumbnailName[0];
    requestObj["coinImages"] = imageNames;
    requestObj["coinId"] = Number(params.coinId);

    let validateObj = validateCreateCoin(requestObj);
    if (validateObj.status) {
      if (
        thumbnail !== undefined &&
        thumbnail !== null &&
        thumbnail.length === 0
      ) {
        dispatch(
          toggleNotificationVisibility({
            isVisible: true,
            status: NotificationType.error,
            message: "Please upload coin thumbnail.",
          })
        );
        return;
      }
      if (images !== undefined && images !== null && images.length === 0) {
        dispatch(
          toggleNotificationVisibility({
            isVisible: true,
            status: NotificationType.error,
            message: "Please upload coin images.",
          })
        );
        return;
      }

      // console.log(requestObj);
      dispatch(updateCoin(requestObj))
    } else {
      dispatch(
        toggleNotificationVisibility({
          isVisible: true,
          status: NotificationType.error,
          message: validateObj.message,
        })
      );
    }
  };

  const handlePublish=()=>{
    dispatch(toggleNotificationVisibility({
      isVisible:true,
      status:NotificationType.error,
      message:"You cannot update published coin."
    }))
  }

  return (
    <Fragment>
      <HeaderView>
        <ViewHeader
          title={"Update Coin"}
          isBackButtonRequired={true}
          backButtonRedirectionUrl={adminRouts.coinList}
        />
      </HeaderView>
      <FormContainer>
        <SectionWrapper>
          <FormWrapper>
            <SectionTitle>Update Coin</SectionTitle>
            <FormBody>{createCoinView}</FormBody>
          </FormWrapper>
        </SectionWrapper>
        <ImageSection>
          <CoinThumbnailUploader isShowBtn={true} isLottery={false}/>
          <CoinImageUploader isShowBtn={true} />
        </ImageSection>
      </FormContainer>
      <ActionBtn>
        <Button
          title={"Cancel"}
          btnSize={ButtonSize.md}
          btnVariant={ButtonVariant.danger}
          clicked={() => navigate(adminRouts.coinList)}
        />
        <Button
          title={singleCoin.isPublished? "Punlished": "Update Coin"}
          btnSize={ButtonSize.md}
          btnVariant={singleCoin.isPublished? ButtonVariant.secondary : ButtonVariant.primaryFilled}
          clicked={singleCoin.isPublished? handlePublish : validateForm}
        />
      </ActionBtn>
    </Fragment>
  );
};

export default UpdateCoin;
